/**
 * Convert a string to camelCase
 *
 * @param {String} string The string to convert
 * @returns {String} The camelCased string
 * @example
 *
 * camelCase('one-two')
 *  => 'oneTwo'
 *
 * camelCase('ONE_TWO')
 *  => 'oneTwo'
 *
 * camelCase('One Two')
 *  => 'oneTwo'
 */
export const camelCase = (string = '') => {
  return string
    .toLowerCase()
    .replace(/^([,._:-\s]+)|([,._:-\s]+)$/g, () => '')
    .replace(/([,._:-\s])(\w)/g, (match) => match[1].toUpperCase())
}
